import useServerClock from "../hooks/useServerClock";
import PopperPopup from "./PopperPopup"; // your PopperPopup

export default function ServerClock() {
  const serverTimeMs = useServerClock();

  if (serverTimeMs == null) {
    return (
      <div className="text-right pr-2 mb-1 flex items-baseline">
        <span className="font-jetbrains text-sm text-gray-400 mr-4">00/00</span>
        <span
          className="calc-font text-xl text-white"
          style={{ fontFamily: "'CalculatorFont', monospace", letterSpacing: "1px" }}
        >
          00:00
        </span>
      </div>
    );
  }

  const d = new Date(serverTimeMs);
  const hh = String(d.getUTCHours()).padStart(2, "0");
  const mm = String(d.getUTCMinutes()).padStart(2, "0");

  // Format MM/DD/YYYY
  const utcDateString = `${String(d.getUTCMonth() + 1).padStart(2, "0")}/${String(
    d.getUTCDate()
  ).padStart(2, "0")}/${d.getUTCFullYear()}`;

  return (
    <div className="text-right pr-2 mb-1 flex items-baseline justify-end">
<PopperPopup popupContent={utcDateString}>
  <span
    className="calc-font text-xl text-white"
    style={{ fontFamily: "'CalculatorFont', monospace", marginLeft: "8px" }}
  >
    {hh}:{mm}
  </span>
</PopperPopup>
    </div>
  );
}
